/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { Monaco } from '../../Editor';

import { builtinFunctions, builtinVariables, keywords, operators, pseudoColumns } from './keyword';

export function getCompletionItems(monaco: Monaco) {
  const convertToCompletionItem = (value: string, type: keyof typeof monaco.languages.CompletionItemKind) => ({
    label: value,
    kind: monaco.languages.CompletionItemKind[type],
    insertText: value,
    insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
  });

  return [
    ...keywords.map((value) => convertToCompletionItem(value, 'Keyword')),
    ...operators.map((value) => convertToCompletionItem(value, 'Operator')),
    ...builtinFunctions.map((value) => convertToCompletionItem(value, 'Function')),
    ...builtinVariables.map((value) => convertToCompletionItem(value, 'Variable')),
    ...pseudoColumns.map((value) => convertToCompletionItem(value, 'Text')),
  ];
}
